import { useEffect, useRef, useState } from 'react';
import { subscribeMeterHistory, getLatestHistorySnapshot } from './meterSocket';
import { matchMeterField } from './meterFields';

const DEFAULT_METER_ID = 'TEST_1_1';

function applyHistory(snapshot, field) {
    if (!field || !snapshot || snapshot.error) return null;
    const values = field.get(snapshot);
    if (!Array.isArray(values)) return null;
    const categories = Array.isArray(snapshot.time_intervals) ? snapshot.time_intervals : [];
    return { categories, values: values.map((v) => Number(v) || 0) };
}

export default function useMeterFieldSeries(title, { meterId = DEFAULT_METER_ID, skip = false } = {}) {
    const field = skip ? null : matchMeterField(title);
    const fieldRef = useRef(field);
    fieldRef.current = field;

    const [state, setState] = useState({ categories: [], values: [] });

    useEffect(() => {
        if (!field || skip) {
            setState({ categories: [], values: [] });
            return;
        }
        const cached = getLatestHistorySnapshot(meterId);
        const applied = cached && applyHistory(cached, field);
        setState(applied || { categories: [], values: [] });
    }, [field?.label, skip, meterId]);

    useEffect(() => {
        if (skip) return undefined;

        const handleSnapshot = (snapshot) => {
            const applied = applyHistory(snapshot, fieldRef.current);
            if (applied) setState(applied);
        };

        return subscribeMeterHistory(meterId, handleSnapshot);
    }, [meterId, skip]);

    return { field, ...state };
}
